/* global WEB_ROOT */

/**
 * Organiser detail resolver.
 * This pure function annotates organiser detail objects with computed values, e.g. formatted dates.
 */
const resolver = organiser => organiser && {
  ...organiser,
  permalink: `/o/${organiser.slug}-${organiser.id}`,
  canonical: `${WEB_ROOT}/o/${organiser.slug}-${organiser.id}`,
};

export default resolver;



// WEBPACK FOOTER //
// ./app/src/state/resolvers/organiser.js